import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import { toast } from 'react-toastify';
import { get, orderBy } from 'lodash';
import messages from 'containers/AttributionManager/messages';
import { translate } from 'containers/services/translate';
import {
  StyledGridContainer,
  StyledTitleAssignement,
} from 'containers/AttributionManager/styles';
import { constructAssignedManagerIds } from 'containers/AttributionManager/utils';
import AssignedManager from 'containers/AttributionManager/ManagerCard/AssignedManager';
import UnassignedManager from 'containers/AttributionManager/ManagerCard/UnassignedManager';
import AssignedManagerHead from 'containers/AttributionManager/ManagerCard/AssignedManagerHead';
import UnassignedManagerHead from 'containers/AttributionManager/ManagerCard/UnassignedManagerHead';
import { extractInboxesByUserId } from 'containers/AttributionManager/utils';
export interface ManagerContainerProps {
  intl: IntlShape;
  usersInboxe: any;
  usersInboxes: any;
  managers: any;
  requestUpdateAssignementInboxes: Function;
  requestGetUsersInboxes: Function;
  selectedInboxe: any;
  countInboxes: any;
  listings: any;
  isTransactionAttribution?: boolean;
  selectedArea?: any;
}

export const ManagerContainer: React.FC<ManagerContainerProps> = (
  props,
): JSX.Element => {
  const [isSelectedManagers, setIsSelectedManagers] = useState(true);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [
    selectAllUnassignedManagers,
    setSelectAllUnassignedManagers,
  ] = useState(false);
  const [searchNameAssignedManager, setSearchNameAssignedManager] = useState(
    '',
  );
  const [sortAssignedManager, setSortAssignedManager] = useState('alphaOrder');
  const [sortUnAssignedManager, setSortUnAssignedManager] = useState(
    'alphaOrder',
  );
  const [
    searchNameUnAssignedManager,
    setSearchNameUnAssignedManager,
  ] = useState('');
  const [
    openUnassignedManagerConfirmationDialog,
    setOpenUnassignedManagerConfirmationDialog,
  ] = useState(false);
  const [ListAssignedManager, setListAssignedManager] = useState([]);
  const [ListUnAssignedManager, setListUnAssignedManager] = useState([]);
  const sortList = (payload: any, list: any) => {
    let sortedList;
    const formatAssignedManagerNumberOfTasks = list.map((item: any) => ({
      ...item,
      tasks: extractInboxesByUserId(props.usersInboxes, item.userPrivilegesId)
        ?.length,
    }));
    if (payload === 'alphaOrder') {
      sortedList = orderBy(
        formatAssignedManagerNumberOfTasks,
        [el => el?.sagisName?.toLowerCase()],
        ['asc'],
      );
    } else {
      sortedList = orderBy(formatAssignedManagerNumberOfTasks, 'tasks', [
        payload,
      ]);
    }
    return sortedList;
  };
  const sortListUnssignedManager = (payload: any, list: any) => {
    let sortedList;
    const formatAssignedManagerNumberOfTasks = list.map((item: any) => ({
      ...item,
      tasks: extractInboxesByUserId(props.usersInboxes, item.id)?.length,
    }));
    if (payload === 'alphaOrder') {
      sortedList = orderBy(
        formatAssignedManagerNumberOfTasks,
        [el => el?.sagisName?.toLowerCase()],
        ['asc'],
      );
    } else {
      sortedList = orderBy(formatAssignedManagerNumberOfTasks, 'tasks', [
        payload,
      ]);
    }
    return sortedList;
  };
  useEffect(() => {
    setListAssignedManager(sortList('alphaOrder', props.usersInboxe) as any);
    setListUnAssignedManager(
      sortListUnssignedManager(
        'alphaOrder',
        props.managers.filter(
          (item: any) =>
            !constructAssignedManagerIds(props.usersInboxe).includes(item.id),
        ),
      ) as any,
    );
  }, [props.usersInboxe]);
  const handleCloseConfirmationDialog = () => {
    setOpenConfirmationDialog(false);
  };
  const successCallBack = () => {
    toast.success(translate(messages.successToastUnassignedManager, props));
    props.requestGetUsersInboxes();
  };

  const handleCloseUnassignedManagerConfirmationDialog = () => {
    setOpenUnassignedManagerConfirmationDialog(false);
  };
  const handleValidateDialog = (payload: any) => {
    props.requestUpdateAssignementInboxes(
      {
        ...payload,
        isUpdateAssignement: true,
      },
      successCallBack,
    );
  };
  const handleOpenUnassignedDialog = () => {
    setOpenUnassignedManagerConfirmationDialog(true);
  };
  const handleOpenConfirmationDialog = () => {
    setOpenConfirmationDialog(true);
  };
  const handleValidateUnassigndManagerDialog = (payload: any) => {
    props.requestUpdateAssignementInboxes(
      {
        ...payload,
        isUpdateAssignement: false,
      },
      successCallBack,
    );
  };

  const handleChangeSortAssignedManager = (payload: any) => {
    setSortAssignedManager(payload);
    setListAssignedManager(sortList(payload, ListAssignedManager) as any);
  };
  const handleChangeInputSearch = (payload: any) => {
    setSearchNameAssignedManager(payload);
    if (payload === '') {
      setListAssignedManager(props.usersInboxe);
    }
    const formattedFilterQuery = payload.trim().toLowerCase();
    setListAssignedManager(
      props.usersInboxe.filter(
        (inbox: any) =>
          inbox.sagisName.toLowerCase().indexOf(formattedFilterQuery) !== -1,
      ),
    );
  };
  const handleChangeInputUnassignedSearch = (payload: any) => {
    setSearchNameUnAssignedManager(payload);
    const unassignedManager = props.managers.filter(
      (item: any) =>
        !constructAssignedManagerIds(props.usersInboxe).includes(item.id),
    );
    if (searchNameUnAssignedManager === '') {
      return unassignedManager;
    }

    const formattedFilterQuery = payload.trim().toLowerCase();

    setListUnAssignedManager(
      unassignedManager.filter(
        (inbox: any) =>
          inbox.sagisName.toLowerCase().indexOf(formattedFilterQuery) !== -1,
      ),
    );
  };

  const handleChangeSortUnAssignedManager = (payload: any) => {
    setSortUnAssignedManager(payload);
    setListUnAssignedManager(
      sortListUnssignedManager(payload, ListUnAssignedManager) as any,
    );
  };
  return (
    <>
      <Grid container direction="row" style={StyledGridContainer} spacing={0}>
        <Grid item xs={12}>
          <AssignedManagerHead
            title={translate(messages.assignedUsersTitle, props)}
            setIsSelectedManagers={setIsSelectedManagers}
            isSelectedManagers={isSelectedManagers}
            isAssignedManagers={true}
            handleOpenConfirmationDialog={handleOpenConfirmationDialog}
            searchNameAssignedManager={searchNameAssignedManager}
            handleChangeInputSearch={handleChangeInputSearch}
            sortAssignedManager={sortAssignedManager}
            handleChangeSortAssignedManager={handleChangeSortAssignedManager}
            isTransactionAttribution={props.isTransactionAttribution}
          />
        </Grid>
        <Grid item xs={12} style={{ padding: '0px 16px 24px 16px' }}>
          <span style={StyledTitleAssignement}>
            {get(
              get(props.listings, 'managerInboxes', []).find(
                (el: any) => el.id === props.selectedInboxe,
              ),
              'title',
            )}
          </span>
        </Grid>
        <Grid item xs={12} style={{ padding: '0px 16px 24px 16px' }}>
          <AssignedManager
            List={ListAssignedManager}
            isSelectedManagers={isSelectedManagers}
            usersInboxes={props.usersInboxes}
            handleValidateDialog={handleValidateDialog}
            openConfirmationDialog={openConfirmationDialog}
            setOpenConfirmationDialog={setOpenConfirmationDialog}
            handleCloseConfirmationDialog={handleCloseConfirmationDialog}
            countInboxes={props.countInboxes}
            listings={props.listings}
            selectedArea={props.selectedArea}
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        style={{ ...StyledGridContainer, marginTop: 20 }}
      >
        <Grid item xs={12}>
          <UnassignedManagerHead
            title={translate(messages.unassignedTaskTitle, props)}
            handleOpenUnassignedDialog={handleOpenUnassignedDialog}
            selectAllUnassignedManagers={selectAllUnassignedManagers}
            setSelectAllUnassignedManagers={setSelectAllUnassignedManagers}
            searchNameUnAssignedManager={searchNameUnAssignedManager}
            handleChangeInputUnassignedSearch={
              handleChangeInputUnassignedSearch
            }
            sortUnAssignedManager={sortUnAssignedManager}
            handleChangeSortUnAssignedManager={
              handleChangeSortUnAssignedManager
            }
            isTransactionAttribution={props.isTransactionAttribution}
          />
        </Grid>
        <Grid item style={{ padding: '0px 16px 24px 16px' }}>
          <UnassignedManager
            List={ListUnAssignedManager}
            isSelectedManagers={false}
            usersInboxes={props.usersInboxes}
            openUnassignedManagerConfirmationDialog={
              openUnassignedManagerConfirmationDialog
            }
            handleCloseUnassignedManagerConfirmationDialog={
              handleCloseUnassignedManagerConfirmationDialog
            }
            handleValidateDialog={handleValidateUnassigndManagerDialog}
            selectedInboxe={props.selectedInboxe}
            setSelectAllUnassignedManagers={setSelectAllUnassignedManagers}
            selectAllUnassignedManagers={selectAllUnassignedManagers}
            selectedArea={props.selectedArea}
            listings={props.listings}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default injectIntl(ManagerContainer);
